let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("f6k7w"), load("7ZBIQ"), load("kpzlp")]).then(() => parcelRequire('i34K4'));